"use client";

import useHasCookieConsent from "@/lib/client/useHasCookieConsent";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./CookieConsent.module.css";

//#region [Props]
type CookieConsentProps = {
    cinemaName: string;
};
//#endregion

//#region [Component]
export default function CookieConsent({ cinemaName }: CookieConsentProps) {
    const [hasConsent] = useHasCookieConsent();
    const [askForConsent, setAskForConsent] = useState(false)
    // TODO: This should be handled with useSyncExternalStore and CookieStore api when that api is mature
    useEffect(() => {
        console.debug("HAS CONSENT?", hasConsent);
        if (hasConsent === null) {
            setAskForConsent(true);
        }
    }, [hasConsent]);

    if (askForConsent && typeof window !== "undefined") {
        return createPortal(<CookieConsentForm cinemaName={cinemaName} />, document.body);
    }

    return null;
}
//#endregion


function CookieConsentForm({ cinemaName }: CookieConsentProps) {
    const [, updateConsent] = useHasCookieConsent();

    const setConsent = (newValue: boolean) => {
        updateConsent(newValue).then(() => {
            window.location.reload();

        });

    }

    return <div className={styles.CookieConsentContainer}>
        <div className={styles.CookieConsentForm}>
            <div>
                <h1>{cinemaName} bruker cookies</h1>
                <p>
                    Vi bruker informasjonskapsler for å gi innhold og annonser et personlig preg, for å levere sosiale mediefunksjoner og for å analysere trafikken vår.
                    Vi deler dessuten informasjon om hvordan du bruker nettstedet vårt, med partnerne våre innen sosiale medier,
                    annonsering og analysearbeid, som kan kombinere den med annen informasjon du har gjort tilgjengelig for dem, eller som de har samlet inn gjennom din bruk av tjenestene deres.
                </p>
            </div>

            <div className={styles.ConsentButtonRow}>
                <button className={styles.ConsentButton} onClick={() => { setConsent(false); }}>Avslå</button>
                <button className={styles.ConsentButton} onClick={() => { setConsent(true); }}>Godta</button>
            </div>
        </div>
    </div>
}